module.exports = __webpack_public_path__ + "static/img_mundo-dced03644808fc9ccd970ca609f5c9c7.jpg";